import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { Wordmark } from "./Brand";

const IG = "https://instagram.com/onelease.app";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-ol-ink text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <span className="inline-flex items-center gap-2.5">
              <span className="brand-word text-2xl tracking-tight text-white"><b>One</b><span className="opacity-80">Lease</span></span>
            </span>
            <p className="mt-4 text-white/60 leading-relaxed">
              One application. One verification. One secure profile that works across every
              student property and leasing company.
            </p>
          </div>

          <div className="flex flex-col gap-5">
            <a
              href={`mailto:onelease.app@gmail.com`}
              data-testid="footer-email"
              className="inline-flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-200"
            >
              <EnvelopeSimple size={22} weight="bold" className="text-ol-blue" />
              Questions? Email us at onelease.app@gmail.com
            </a>
            <a
              href={IG}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-200"
            >
              <InstagramLogo size={22} weight="bold" className="text-ol-blue" />
              @onelease.app
            </a>
            <Link
              to="/privacy-terms"
              data-testid="footer-privacy-terms"
              className="text-white/60 hover:text-white transition-colors duration-200 text-sm"
            >
              Privacy Policy &amp; Terms of Service
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/40">
          <span>© {new Date().getFullYear()} OneLease. All rights reserved.</span>
          <span>Student housing, simplified.</span>
        </div>
      </div>
    </footer>
  );
}
